"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _commonAccordion = require("@mmc/common-accordion");

var _commonRichText = require("@mmc/common-rich-text");

var _commonI18n = require("@mmc/common-i18n");

var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");

var _text = require("@mmc/text");

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _configuratorAccessoriesSelector = _interopRequireDefault(require("../styles/configurator-accessories-selector.css"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react/prefer-stateless-function */

/* eslint-disable react/destructuring-assignment */
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
    appendImageOptimization = dataUtils.appendImageOptimization;
var isIE11 = false;

if (typeof navigator !== 'undefined') {
  if (navigator.userAgent.match(/Trident\/7\./)) {
    // eslint-disable-line
    isIE11 = true;
  }
}

var renderPanelHeader = function renderPanelHeader(params) {
  var accessory = params.accessory,
      selectedAccessories = params.selectedAccessories,
      forcedOptionCodes = params.forcedOptionCodes,
      notCompatibleOptionCodes = params.notCompatibleOptionCodes,
      changeEvent = params.changeEvent,
      index = params.index,
      theme = params.theme,
      config = params.config,
      disclaimerData = params.disclaimerData,
      accessoriesPriceDisclaimerId = params.accessoriesPriceDisclaimerId;
  return /*#__PURE__*/_react["default"].createElement("h2", {
    key: index + "-header"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    id: "accessoryList-" + accessory.code,
    name: "accessory-" + accessory.type,
    value: accessory.code,
    type: "checkbox",
    className: _configuratorAccessoriesSelector["default"].optionInput,
    checked: selectedAccessories.includes(accessory.code),
    onChange: changeEvent,
    disabled: forcedOptionCodes.includes(accessory.code) || notCompatibleOptionCodes.includes(accessory.code)
  }), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "accessoryList-" + accessory.code,
    className: _configuratorAccessoriesSelector["default"].optionLabel
  }, accessory.label), accessory.price && /*#__PURE__*/_react["default"].createElement("span", {
    className: _configuratorAccessoriesSelector["default"].priceLabel + " " + theme.bodyCopy
  }, accessory.price.value !== undefined && handleNestedProp(accessory, 'accessory.price.label'), /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
    format: "price",
    returnZero: true,
    options: {
      value: handleNestedProp(accessory, 'accessory.price.value'),
      currency: handleNestedProp(config, 'config.currencyFormat'),
      locale: handleNestedProp(config, 'config.localeCode')
    },
    addPriceDisclaimer: accessoriesPriceDisclaimerId ? true : false,
    priceDisclaimerId: accessoriesPriceDisclaimerId,
    disclaimerData: disclaimerData
  })));
};

var renderPanelBody = function renderPanelBody(accessory, index, theme, disclaimerData) {
  var description = handleNestedProp(accessory, 'accessory.titleAndText.text');
  var imageSrc = handleNestedProp(accessory, 'accessory.image.image');
  return /*#__PURE__*/_react["default"].createElement("article", {
    key: index + "-panel",
    className: "" + _configuratorAccessoriesSelector["default"].accordionDetails
  }, imageSrc !== ' ' && /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    className: _configuratorAccessoriesSelector["default"].accordionDetailImage,
    src: appendImageOptimization(imageSrc, 600, undefined, undefined, 70) // eslint-disable-line
    ,
    alt: handleNestedProp(accessory, 'accessory.image.altText')
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    className: _configuratorAccessoriesSelector["default"].accordionText + " " + theme.smallType,
    text: description !== ' ' && /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
      theme: theme,
      html: description
    }),
    tag: "div",
    disclaimerData: disclaimerData
  }));
};

var renderPanels = function renderPanels(params) {
  var accessoryList = params.accessoryList,
      selectedAccessories = params.selectedAccessories,
      forcedOptionCodes = params.forcedOptionCodes,
      notCompatibleOptionCodes = params.notCompatibleOptionCodes,
      changeEvent = params.changeEvent,
      theme = params.theme,
      config = params.config,
      disclaimerData = params.disclaimerData,
      accessoriesPriceDisclaimerId = params.accessoriesPriceDisclaimerId;
  var accessoryListMarkup = [];
  accessoryList.forEach(function (accessory, index) {
    if (accessory.code !== null) {
      accessoryListMarkup.push(renderPanelHeader({
        accessory: accessory,
        selectedAccessories: selectedAccessories,
        forcedOptionCodes: forcedOptionCodes,
        notCompatibleOptionCodes: notCompatibleOptionCodes,
        changeEvent: changeEvent,
        index: index,
        theme: theme,
        config: config,
        disclaimerData: disclaimerData,
        accessoriesPriceDisclaimerId: accessoriesPriceDisclaimerId
      }));
      accessoryListMarkup.push(renderPanelBody(accessory, index, theme, disclaimerData));
    }
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, accessoryListMarkup);
};

var AccordionWrapper = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(AccordionWrapper, _React$Component);

  function AccordionWrapper() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = AccordionWrapper.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        theme = _this$props.theme,
        selectedAccessories = _this$props.selectedAccessories,
        forcedOptionCodes = _this$props.forcedOptionCodes,
        notCompatibleOptionCodes = _this$props.notCompatibleOptionCodes,
        changeEvent = _this$props.changeEvent,
        config = _this$props.config,
        disclaimerData = _this$props.disclaimerData,
        accessoriesPriceDisclaimerId = _this$props.accessoriesPriceDisclaimerId;
    var accessoryList = this.props.filteringOptions || [];

    if (isIE11) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _configuratorAccessoriesSelector["default"].accordion + " " + _configuratorAccessoriesSelector["default"].headingsOutside
      }, /*#__PURE__*/_react["default"].createElement(_commonAccordion.CommonAccordion, {
        theme: theme,
        multiselectable: true,
        headingsOutside: true,
        columns: 2,
        headerClasses: [_configuratorAccessoriesSelector["default"].accessoryHeader],
        panelClasses: [_configuratorAccessoriesSelector["default"].accessoryPanel]
      }, renderPanels({
        accessoryList: accessoryList,
        selectedAccessories: selectedAccessories,
        forcedOptionCodes: forcedOptionCodes,
        notCompatibleOptionCodes: notCompatibleOptionCodes,
        changeEvent: changeEvent,
        theme: theme,
        config: config,
        disclaimerData: disclaimerData,
        accessoriesPriceDisclaimerId: accessoriesPriceDisclaimerId
      })));
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _configuratorAccessoriesSelector["default"].accordion
    }, /*#__PURE__*/_react["default"].createElement(_commonAccordion.CommonAccordion, {
      theme: theme,
      multiselectable: true,
      columns: 2,
      headerClasses: [_configuratorAccessoriesSelector["default"].accessoryHeader],
      panelClasses: [_configuratorAccessoriesSelector["default"].accessoryPanel]
    }, renderPanels({
      accessoryList: accessoryList,
      selectedAccessories: selectedAccessories,
      forcedOptionCodes: forcedOptionCodes,
      notCompatibleOptionCodes: notCompatibleOptionCodes,
      changeEvent: changeEvent,
      theme: theme,
      config: config,
      disclaimerData: disclaimerData,
      accessoriesPriceDisclaimerId: accessoriesPriceDisclaimerId
    })));
  };

  return AccordionWrapper;
}(_react["default"].Component);

AccordionWrapper.displayName = 'AccordionWrapper';

var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(AccordionWrapper);

exports["default"] = _default;